var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.44446V7.33333H2.44446V2.44446H7.33333V0H2.44446C1.09387 0 0 1.09387 0 2.44446Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44446 14.6667H0V19.5555C0 20.9061 1.09387 22 2.44446 22H7.33333V19.5555H2.44446V14.6667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 19.5555H14.6667V22H19.5556C20.9062 22 22.0001 20.9061 22.0001 19.5555V14.6667H19.5556V19.5555Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 0H14.6667V2.44446H19.5556V7.33333H22.0001V2.44446C22.0001 1.09387 20.9062 0 19.5556 0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.00fa49c9.svg";
export { ForwardRef as ReactComponent };